import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const lines = ['Big moments don’t ask politely.', 'They ask whether you lean back…', '…or lean in.'];
export const Screen1Hero = ({
  onNext
}: Props) => {
  const [lineIndex, setLineIndex] = useState(0);
  useEffect(() => {
    if (lineIndex < lines.length - 1) {
      const t = setTimeout(() => setLineIndex(lineIndex + 1), 1800);
      return () => clearTimeout(t);
    }
  }, [lineIndex]);
  return <div className="relative w-full h-full overflow-hidden bg-black" data-id="element-296">
      {/* Background Video */}
      <div className="absolute inset-0" data-id="element-297">
        <video src="https://cdn.magicpatterns.com/uploads/hC1MFgigWu74SDDXUqfodA/sad.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-298" />
      </div>

      {/* Cinematic vignettes */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/90" data-id="element-299" />
      <div className="absolute inset-0 bg-gradient-to-tr from-red-950/40 via-transparent to-transparent mix-blend-multiply" data-id="element-300" />

      {/* Top label */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3,
      duration: 0.6
    }} className="absolute top-8 left-0 right-0 flex justify-center" data-id="element-301">
        <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md rounded-full px-4 py-1.5 border border-white/10" data-id="element-302">
          <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" data-id="element-303" />
          <span className="text-[10px] tracking-[0.3em] uppercase text-white font-semibold" data-id="element-304">
            ERA Pulse
          </span>
        </div>
      </motion.div>

      {/* Headlines */}
      <div className="absolute inset-0 flex flex-col justify-end p-8 pb-32" data-id="element-305">
        <AnimatePresence mode="wait" data-id="element-306">
          <motion.h1 key={lineIndex} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="text-4xl font-bold text-white leading-tight tracking-tight" style={{
          textShadow: '0 2px 30px rgba(0,0,0,0.5)'
        }} data-id="element-307">
            {lines[lineIndex]}
          </motion.h1>
        </AnimatePresence>

        {/* Progress lines */}
        <div className="flex space-x-1.5 mt-6" data-id="element-308">
          {lines.map((_, i) => <div key={i} className={`h-0.5 flex-1 rounded-full transition-colors duration-500 ${i <= lineIndex ? 'bg-red-500' : 'bg-white/20'}`} data-id="element-309" />)}
        </div>
      </div>

      {/* CTA */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: lineIndex === lines.length - 1 ? 1 : 0,
      y: lineIndex === lines.length - 1 ? 0 : 20
    }} transition={{
      duration: 0.6,
      delay: 0.3
    }} className="absolute bottom-10 left-8 right-8" data-id="element-310">
        <button onClick={onNext} className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 shadow-[0_10px_40px_rgba(220,38,38,0.4)] active:scale-[0.98] transition-all" data-id="element-311">
          <span className="text-lg" data-id="element-312">I’m in</span>
          <ArrowRight className="w-5 h-5" data-id="element-313" />
        </button>
      </motion.div>
    </div>;
};